export default function reducer(state = {
  emoticones: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_EMOTICONES": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}